import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Settings,
  Users,
  Bell,
  ClipboardList,
  MapPin,
  Power,
  ChevronLeft,
  Menu,
  Banknote,
  BarChartBig,
  LucideShoppingCart,
  CalendarClock,
  BadgePercent,
  CalendarCheck,
  ListChecks,
  Crown,
  UserCircle,
  IndianRupee,
} from "lucide-react";

import { useGlobalContext } from "../../../GlobalContext";
import ConfirmLogoutModal from "../../Utils/ConfirmLogoutModal";
import Logo from "../../../Images/Packky Logo Blue.svg";
import Logo1 from "../../../Images/Packky small blue.svg";

const iconMap = {
  Volunteer: UserCircle,
  // "Volunteer Team": Users,
  "Volunteer Shops": LucideShoppingCart,
  "Attendance": CalendarCheck,
};

export default function VolunteerSidebar({ sidebarOpen, setSidebarOpen }) {
  const { baseurl, token, accessToken, setIsUnauthorised, AdminId } =
    useGlobalContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuItems, setMenuItems] = useState([]);

  // useEffect(() => {
  //   const fetchVolunteerAccess = async () => {
  //     try {
  //       const volunteerData = JSON.parse(
  //         sessionStorage.getItem("volunteerData")
  //       );

  //       if (!volunteerData?.userId) return;

  //       const res = await fetch(
  //         `${baseurl}/api/VolunteerAdmin/v1.0/getVolunteerAccess`,
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Basic ${token}`,
  //           },
  //           body: JSON.stringify({
  //             userid: volunteerData.userId,
  //           }),
  //         }
  //       );

  //       const data = await res.json();

  //       if (data.responseCode === "00") {
  //         // null submenu filter karo
  //         const filteredMenus = data.response.map((menu) => ({
  //           ...menu,
  //           submenus: menu.submenus?.filter(
  //             (sub) => sub.submenu_title && sub.submenu_url
  //           ),
  //         }));

  //         setMenuItems(filteredMenus);
  //       } else if (data.responseCode === "401") {
  //         setIsUnauthorised(true);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching volunteer access:", error);
  //     }
  //   };

  //   fetchVolunteerAccess();
  // }, []);

  useEffect(() => {
    const customMenu = [
      { menu_title: "Volunteer", menu_url: "/volunteer" },
      // { menu_title: "Volunteer Team", menu_url: "/volunteer/team" },
      { menu_title: "Volunteer Shops", menu_url: "/volunteer/shops" },
      { menu_title: "Attendance", menu_url: "/volunteer/attendance" },
    ];

    setMenuItems(customMenu);
  }, []);

  return (
    <>
      {/* Mobile Toggle Button - Only visible on mobile */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="md:hidden fixed top-4 right-4 z-50 p-2 rounded-lg shadow-lg"
        style={{
          backgroundColor: "#2563EB",
          color: "#ffff",
        }}
      >
        <Menu size={13} />
      </button>

      {/* Mobile Top Navigation - Only visible on mobile when sidebar is open */}
      {sidebarOpen && (
        <>
          {/* Mobile Overlay */}
          <div
            className="md:hidden fixed inset-0   z-30"
            onClick={() => setSidebarOpen(false)}
          />

          {/* Mobile Top Nav */}
          <div
            className="md:hidden fixed top-0 left-0 right-0 z-40 p-2 pt-2"
            style={{
              backgroundColor: "#2563EB",
              color: "#ffff",
              fontWeight: "600",
            }}
          >
            {/* Header with logo and close button */}
            <div className="flex items-center justify-between mb-4">
              <div
                className="h-10 content-center"
                style={{
                  padding: "10px",
                  backgroundColor: "white",
                  borderRadius: "1.5rem",
                }}
              >
                <img className="h-6" src={Logo} alt="" />
              </div>

              <button
                onClick={() => setSidebarOpen(false)}
                className="p-1 rounded-full hover:bg-white/20 transition-colors"
              >
                {/* <X size={24} /> */}
              </button>
            </div>

            {/* Navigation Menu - Horizontal scroll on mobile */}
            <div
              className="block md:hidden flex overflow-x-auto space-x-2 px-2 py-1 scrollbar-hide bg-[#2563EB] text-white text-sm"
              style={{ height: "52px" }}
            >
              {menuItems.map((item) => {
                const routePath = item.menu_url;
                //               const routePath =
                // item.menu_url?.startsWith("/volunteer")
                //   ? item.menu_url
                //   : `/volunteer${item.menu_url}`;

                const isActive = location.pathname === routePath;
                const Icon = iconMap[item.menu_title] || LayoutDashboard;

                return (
                  <div
                    key={item.menu_title}
                    onClick={() => {
                      navigate(routePath);
                      setSidebarOpen(false);
                    }}
                    className={`flex flex-col items-center justify-center px-2 cursor-pointer rounded-lg transition-all ${
                      isActive ? "bg-white bg-opacity-20" : "hover:bg-white/20"
                    }`}
                    style={{ minWidth: "54px" }}
                  >
                    <Icon size={14} />
                    <span className="text-[10px]">{item.menu_title}</span>
                  </div>
                );
              })}

              <ConfirmLogoutModal
                trigger={
                  <div
                    className="flex flex-col items-center justify-center px-2 cursor-pointer hover:bg-red-500 transition-colors rounded-lg"
                    style={{ minWidth: "54px" }}
                  >
                    <Power size={14} />
                    <span className="text-[10px]">Logout</span>
                  </div>
                }
              />
            </div>
          </div>
        </>
      )}

      {/* Desktop/Tablet Sidebar - Hidden on mobile, visible on md and up */}
      <div
        className={`hidden md:flex ${
          sidebarOpen ? "w-56" : "md:w-16"
        } transition-all duration-200 ease-in-out flex-col h-full`}
        style={{
          backgroundColor: "#2563EB",
          color: "#ffff",
          fontWeight: "600",
        }}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <span className="text-lg font-bold whitespace-nowrap">
            {sidebarOpen ? (
              <div
                className="h-15 content-center"
                style={{
                  padding: "15px",
                  backgroundColor: "white",
                  borderRadius: "2rem",
                }}
              >
                <img className="h-7" src={Logo} alt="" />
              </div>
            ) : (
              ""
            )}
          </span>

          {/* Desktop toggle button */}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-1 rounded-full hover:bg-white/20 transition-colors"
          >
            {sidebarOpen ? (
              <ChevronLeft size={20} />
            ) : (
              <div className=" bg-white rounded">
                <img className=" bg-white rounded " src={Logo1} alt="" />
              </div>
            )}
          </button>
        </div>

        <div className="flex-1 py-2 space-y-2">
          {menuItems.map((item) => {
            const routePath = item.menu_url;
            const isActive = location.pathname === routePath;
            const Icon = iconMap[item.menu_title] || LayoutDashboard;

            return (
              <div
                key={item.menu_title}
                onClick={() => navigate(routePath)}
                className={`flex items-center gap-3 p-3 cursor-pointer transition-all rounded-md ${
                  isActive
                    ? "bg-white/20 border-l-4 border-white"
                    : "hover:bg-white/20"
                }`}
              >
                <Icon size={20} />
                {sidebarOpen && (
                  <span className="text-sm">{item.menu_title}</span>
                )}
              </div>
            );
          })}
        </div>

        <div className="p-4 border-t border-gray-700">
          <ConfirmLogoutModal
            trigger={
              <div className="flex items-center space-x-2 cursor-pointer hover:bg-red-500 transition-colors p-2 rounded text-white">
                <Power size={20} />
                {sidebarOpen && <span>Logout</span>}
              </div>
            }
          />
        </div>
      </div>
    </>
  );
}
